interface ValidationResult {
  valid: boolean;
  error?: string;
  rowCount?: number;
}

const REQUIRED_HEADERS = ["CAVNUM_LOJA", "CAVDOCCOD"];
const MAX_ROWS = 50000;

export async function validateImportCSV(file: File): Promise<ValidationResult> {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const content = e.target?.result as string;
      if (!content || content.trim() === "") {
        resolve({ valid: false, error: "Arquivo esta vazio" });
        return;
      }

      const lines = content.split(/\r?\n/).filter((line) => line.trim());
      if (lines.length === 0) {
        resolve({ valid: false, error: "Arquivo esta vazio" });
        return;
      }

      // Parse headers (first line)
      const headers = lines[0].split(",").map((h) => h.trim().toUpperCase());

      // Check required headers
      for (const required of REQUIRED_HEADERS) {
        if (!headers.includes(required)) {
          resolve({
            valid: false,
            error: `Coluna obrigatoria ausente: ${required}`,
          });
          return;
        }
      }

      const rowCount = lines.length - 1; // Exclude header

      if (rowCount > MAX_ROWS) {
        resolve({
          valid: false,
          error: `Limite maximo de ${MAX_ROWS.toLocaleString("pt-BR")} linhas por importacao`,
        });
        return;
      }

      resolve({ valid: true, rowCount });
    };

    reader.onerror = () => {
      resolve({ valid: false, error: "Erro ao ler arquivo" });
    };

    reader.readAsText(file);
  });
}
